module.exports = __webpack_public_path__ + "static/media/logo_list_shack.3a5bbb3d.png";